import type { ChangeEvent } from 'react';
import { useCallback } from 'react';

import { ShareOutlined } from '@/shared/ui/icons';

import useShareButton from '@/components/ShareButton/useShareButton';
import ShareDialog from '@/components/ShareDialog';
import Button from '@/shared/ui/primitives/Button';
import Typography from '@/shared/ui/typography/Text';

const SharePromptButton = ({ prompt }: { prompt: string }) => {
  const shareUrl = `${window.location.origin}/markets?prompt=${encodeURIComponent(prompt)}`;

  const {
    modalOpen,
    setModalOpen,
    content,
    setContent,
    recipient,
    handleChangeRecipient,
    handleCopyToClipboard,
    sendEmail,
    emailError
  } = useShareButton('', shareUrl);

  const handleClose = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  const handleContentChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setContent(e.target.value);
    },
    [setContent]
  );

  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, [setModalOpen]);

  return (
    <>
      <Button
        sx={{
          backgroundColor: 'gx.actionBarButtonTile',
          height: '34px',
          width: '117px'
        }}
        onClick={handleClick}
      >
        <ShareOutlined />
        <Typography
          sx={{
            fontSize: '14px',
            whiteSpace: 'nowrap'
          }}
        >
          Share prompt
        </Typography>
      </Button>
      <ShareDialog
        content={content}
        emailError={emailError}
        enableSendEmail={false}
        handleChangeRecipient={handleChangeRecipient}
        header='Share GX Go Assistant prompt'
        open={modalOpen}
        recipient={recipient}
        shareUrl={shareUrl}
        onClose={handleClose}
        onContentChange={handleContentChange}
        onCopyClick={handleCopyToClipboard}
        onSendEmail={sendEmail}
      />
    </>
  );
};

export default SharePromptButton;
